import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--ui-spacings-md);

  & > .checkbox-consent > label > span:first-of-type {
    background-color: var(--ui-colors-neutral-200) !important;
  }

  * {
    --field-box-bg: var(--ui-colors-neutral-200);
  }
  input {
    background-color: var(--ui-colors-neutral-200);
  }
`;

export const FieldPair = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  input[type='date'] {
    color: ${({ theme }) => theme.colors.grey.default};
  }

  input[type='date']:focus-within {
    color: ${({ theme }) => theme.colors.grey.dark};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.min_lg}px) {
    flex-direction: row;
    & > div:first-of-type,
    & > div:nth-of-type(2) {
      width: 50%;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    gap: 24px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--ui-spacings-button-gap);
  justify-content: end;
`;

export const ErrorMessage = styled.div`
  background-color: var(--ui-colors-negative-100);
  border-radius: var(--ui-border-radius-sm);
  display: flex;
  gap: var(--ui-spacings-2xs);
  padding: 8px 16px;
`;

export const ImageWrapper = styled.div`
  align-content: center;

  svg {
    width: 24px;
    height: 24px;
  }
`;
